module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-Blue-Monster-Angry-Web-1280.c84856a5.jpg";